import { defineAction } from '~/prix'
import { z } from 'zod'
import benefitProgramCreateAction from './benefitProgramCreate.action.json' with { type: 'json' }
import { benefitProgramObject } from '../benefitProgramObject'

const benefitProgramCreateDefinition = defineAction({
  ...benefitProgramCreateAction,

  input: benefitProgramObject
    .pick({ id: true, name: true, unitValue: true, discountPercent: true, calculationRules: true, active: true })
    .partial({ id: true }),
  output: z.object({ id: benefitProgramObject.shape.id }),
})

export default benefitProgramCreateDefinition
